import { render } from "./casualQues.vue?vue&type=template&id=2c57309a"
import script from "./casualQues.vue?vue&type=script&lang=js"
export * from "./casualQues.vue?vue&type=script&lang=js"

import "./casualQues.vue?vue&type=style&index=0&id=2c57309a&lang=scss"
script.render = render

export default script